/** The Parallax Gate mark (two parallax-shifted rings and a star): the same artwork as the app icon, drawn inline (no image request). */
export function BrandMark({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="60 60 392 392" className={className} aria-hidden focusable="false">
      <g fill="none" strokeWidth="30">
        <circle cx="230" cy="256" r="140" stroke="#4a9eff" />
        <circle cx="282" cy="256" r="140" stroke="#9fd0ff" opacity="0.92" />
      </g>
      <path d="M256 190 Q256 256 322 256 Q256 256 256 322 Q256 256 190 256 Q256 256 256 190Z" fill="#eaf4ff" />
    </svg>
  );
}
